import { render } from "./PassportView.vue?vue&type=template&id=e0b6630e&scoped=true"
import script from "./PassportView.vue?vue&type=script&lang=js"
export * from "./PassportView.vue?vue&type=script&lang=js"

import "./PassportView.vue?vue&type=style&index=0&id=e0b6630e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0b6630e"]])

export default __exports__